

export const FETCH_SALES_PERSON_VEHICLES_REQUEST = "FETCH_SALES_PERSON_VEHICLES_REQUEST"
export const FETCH_SALES_PERSON_VEHICLES_SUCCESS = "FETCH_SALES_PERSON_VEHICLES_SUCCESS"
export const FETCH_SALES_PERSON_VEHICLES_FAILED = "FETCH_SALES_PERSON_VEHICLES_FAILED"